var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgNotificationsButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-notifications-button_svg__cls-6{fill:none}.kpmg-notifications-button_svg__cls-5{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications-button_svg__ICN_Notificari_Hover",
    transform: "translate(-119 -152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications-button_svg__Ellipse_186",
    "data-name": "Ellipse 186",
    transform: "translate(126 172)",
    stroke: "#fff",
    strokeWidth: 1.6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "kpmg-notifications-button_svg__cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.2,
    className: "kpmg-notifications-button_svg__cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications-button_svg__Path_900",
    "data-name": "Path 900",
    fill: "#0054af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6.2C1.787 6.2.8 5.213.8 4V3C.8 1.787 1.787.8 3 .8s2.2.987 2.2 2.2v1c0 1.213-.987 2.2-2.2 2.2z",
    className: "kpmg-notifications-button_svg__cls-5",
    transform: "translate(128 152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 1.6c-.772 0-1.4.628-1.4 1.4v1c0 .772.628 1.4 1.4 1.4.772 0 1.4-.628 1.4-1.4V3c0-.772-.628-1.4-1.4-1.4M3 0a3 3 0 013 3v1a3 3 0 01-6 0V3a3 3 0 013-3z",
    transform: "translate(128 152)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications-button_svg__Rectangle_341",
    "data-name": "Rectangle 341",
    transform: "translate(122 155)",
    fill: "#0054af",
    stroke: "#fff",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 23,
    className: "kpmg-notifications-button_svg__cls-5",
    rx: 9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.4,
    height: 21.4,
    x: 0.8,
    y: 0.8,
    className: "kpmg-notifications-button_svg__cls-6",
    rx: 8.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-notifications-button_svg__Rectangle_340",
    "data-name": "Rectangle 340",
    transform: "translate(119 170)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#0054af",
    stroke: "#fff",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 8,
    className: "kpmg-notifications-button_svg__cls-5",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.4,
    height: 6.4,
    x: 0.8,
    y: 0.8,
    className: "kpmg-notifications-button_svg__cls-6",
    rx: 3.2
  })))));
}

export default SvgKpmgNotificationsButton;